import { NAME } from './constants.js';
import type { AssetsState } from './reducer.js';
import type { AssetsSlice } from './types.js';

export const getState = (state: AssetsSlice): AssetsState => state[NAME];
